import { saveAs } from "file-saver";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { GoRead, GoUnread } from "react-icons/go";
import { RiFileExcel2Line, RiFilePdf2Line } from "react-icons/ri";
import { TbCopy } from "react-icons/tb";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Row,
  Spinner,
  Table,
  Tooltip,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertUTCToLocalTime,
  customOption,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { ApiCourse } from "../../courses/ApiCourse";
import { GetLanguageString, NoResult } from "../../helper/Components";
import {
  DateValidater,
  GetCustomStyles,
  GetFooTableCustomStyles,
  GetSelectedLanguage,
} from "../../helper/Method";
import { ApiUnit } from "../../unit/ApiUnit";
import { ApiNotifications } from "../ApiNotifications";
import { ShowToast } from "../../shared/ShowToast";
const NotificationAlerts = ({ activeTab }) => {
  const notify = (string) => toast.success(string);
  const { t } = useTranslation();
  const [pagination, setPagination] = useState({ activePage: 1 });
  const responsibilityId = encryptStorage.getItem("responsibilityId");
  const loggedInUnitId = encryptStorage.getItem("loggedInUnitId");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);

  const [tooltipOpen, setTooltipOpen] = useState(null);
  const [tooltipOpenCopy, setTooltipOpenCopy] = useState(null);

  const toggleTooltip = (index) => {
    setTooltipOpen((prevOpen) => (prevOpen === index ? null : index));
  };
  const toggleTooltipCopy = (index) => {
    setTooltipOpenCopy((prevOpen) => (prevOpen === index ? null : index));
  };

  const [notificationTypes, setNotificationTypeFilter] = useState([]);
  const [selectedType, setSelectedType] = useState({ value: 0, label: "All" });
  const [approvalStatuses, setApprovalStatusesFilter] = useState([]);
  const [selectedApprovalStatus, setSelectedApprovalStatus] = useState({
    value: -1,
    label: "All",
  });
  const [relevantUnitsList, setRelevantUnitsList] = useState([]);
  const [selectedRelevantUnit, setSelectedRelevantUnit] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dateRangeValidation = {
    startDate: null,
    endDate: null,
  };
  const [dateValidations, setDateValidations] = useState(dateRangeValidation);

  const [units, setUnitsFilter] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState({
    value: "0-0",
    label: "تمام",
  });

  const copyToClipboard = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        notify(t("notifications_comments_copied"));
      })
      .catch((err) => {
        notify("Failed to copy: ", err);
      });
  };

  const [record, setRecord] = useState({
    responsibilityId: responsibilityId,
    loggedInUnitId: loggedInUnitId,
    notificationTypeId: selectedType?.value,
    approvalStatus: selectedApprovalStatus?.value,
    relevantUnit: selectedRelevantUnit?.value,
    startDate: startDate ?? Date.minDate,
    endDate: endDate,
    notificationUnitId: parseInt(selectedUnit?.value.split("-")[0]),
    notificationResponsibilityId: parseInt(selectedUnit?.value.split("-")[1]),
    activePage: 1,
    creationDate: "neutral",
    // pageSize: rows[0].value,
  });

  const handlePageChange = (pageNumber) => {
    setRecord({
      ...record,
      responsibilityId: responsibilityId,
      loggedInUnitId: loggedInUnitId,
      notificationTypeId: selectedType?.value,
      approvalStatus: selectedApprovalStatus?.value,
      relevantUnit: selectedRelevantUnit?.value,
      startDate: startDate ?? Date.minDate,
      endDate: endDate,
      notificationUnitId: parseInt(selectedUnit?.value.split("-")[0]),
      notificationResponsibilityId: parseInt(selectedUnit?.value.split("-")[1]),
      activePage: pageNumber,
      creationDate: "neutral",
    });
    setPagination({
      ...pagination,
      activePage: pageNumber,
    });
  };

  const handleSorting = () => {
    if (
      record.creationDate === "neutral" ||
      record.creationDate === "descending"
    ) {
      setRecord({
        ...record,
        creationDate: "ascending",
      });
    } else if (record.creationDate === "ascending") {
      setRecord({
        ...record,
        creationDate: "descending",
      });
    }
  };

  const handleMarkAsReadOrUnread = (notificationId, approvalStatus, index) => {
    ApiNotifications()
      .markNotificationAsReadOrUnread(notificationId, approvalStatus)
      .then((res) => {
        let tempValues = [...notification];
        tempValues[index].approvalStatus = approvalStatus;
        setNotification(tempValues);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = () => {
    const record = {
      responsibilityId: responsibilityId,
      loggedInUnitId: loggedInUnitId,
      notificationTypeId: selectedType?.value,
      approvalStatus: selectedApprovalStatus?.value,
      relevantUnit: selectedRelevantUnit?.value,
      startDate: startDate ?? Date.minDate,
      endDate: endDate,
      notificationUnitId: parseInt(selectedUnit?.value.split("-")[0]),
      notificationResponsibilityId: parseInt(selectedUnit?.value.split("-")[1]),
      creationDate: "neutral",
    };

    setLoading(true);
    ApiNotifications()
      .getAlertNotificationList(record)
      .then((res) => {
        setPagination(res.data);
        setNotification(res.data.notificationList);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const excelDownload = () => {
    const record = {
      responsibilityId: responsibilityId,
      loggedInUnitId: loggedInUnitId,
      notificationTypeId: selectedType?.value,
      approvalStatus: selectedApprovalStatus?.value,
      relevantUnit: selectedRelevantUnit?.value,
      startDate: startDate ?? Date.minDate,
      endDate: endDate,
      notificationUnitId: parseInt(selectedUnit?.value.split("-")[0]),
      notificationResponsibilityId: parseInt(selectedUnit?.value.split("-")[1]),
      reportType: "notificationAlert",
    };
    setExcelLoading(true);
    ApiNotifications()
      .generateNotificationsReport(record)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "NotificationAlerts.xlsx");

        setExcelLoading(false);
      })
      .catch((err) => {
        setExcelLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (activeTab === "alerts") {
      setLoading(true);
      ApiNotifications()
        .GetNotificationTypes(activeTab)
        .then((res) => {
          setNotificationTypeFilter(res.data);
        })
        .catch((err) => {
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response.data);
          setLoading(false);
        });

      ApiNotifications()
        .GetApprovalStatuses(activeTab)
        .then((res) => {
          setApprovalStatusesFilter(res.data);
        })
        .catch((err) => {
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response.data);
          setLoading(false);
        });

      ApiNotifications()
        .GetNotificationRelevantUnits(activeTab)
        .then((res) => {
          setRelevantUnitsList(res.data);
          setSelectedRelevantUnit(res.data[0]);
        })
        .catch((err) => {
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response.data);
          setLoading(false);
        });

      ApiUnit()
        .GetUnitsForNotificationFilters(
          responsibilityId,
          loggedInUnitId,
          activeTab
        )
        .then((res) => {
          setUnitsFilter(res.data);
        })
        .catch((err) => {
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response.data);
          setLoading(false);
        });
    }
  }, [responsibilityId, loggedInUnitId, activeTab]);

  useEffect(() => {
    if (activeTab === "alerts") {
      setLoading(true);
      ApiNotifications()
        .getAlertNotificationList(record)
        .then((res) => {
          setPagination(res.data);
          setNotification(res.data.notificationList);
          setLoading(false);
        })
        .catch((err) => {
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response.data);
          setLoading(false);
        });
    }
  }, [record, responsibilityId, loggedInUnitId, activeTab]);

  const handleSelectChangeNotificationType = (event) => {
    setSelectedType(event);
  };

  const handleSelectChangeUnit = (event) => {
    setSelectedUnit(event);
  };

  const handleSelectRelevantUnit = (event) => {
    setSelectedRelevantUnit(event);
  };

  const handleSelectChangeApprovalStatus = (event) => {
    setSelectedApprovalStatus(event);
  };

  const handleInputChangeStartDate = (value) => {
    if (DateValidater(value, endDate)) {
      setStartDate(value);
      setDateValidations(dateRangeValidation);
    } else {
      setDateValidations({
        ...dateValidations,
        startDate: (
          <GetLanguageString props="common_start_date_validation_message" />
        ),
      });
    }
  };

  const handleInputChangeEndDate = (value) => {
    if (DateValidater(startDate, value)) {
      setEndDate(value);
      setDateValidations(dateRangeValidation);
    } else {
      setDateValidations({
        ...dateValidations,
        endDate: (
          <GetLanguageString props="common_end_date_validation_message" />
        ),
      });
    }
  };

  let recordIndex = pagination.pageSize * (pagination.activePage - 1) + 1;

  let pageInfo = `Displaying ${recordIndex}-${
    recordIndex + pagination.pageSize - 1 < pagination.totalItem
      ? recordIndex + pagination.pageSize - 1
      : pagination.totalItem
  } of ${pagination.totalItem}`;
  const downloadPdf = (id, courseData) => {
    const toastId = toast.loading(t("downloading_pdf"));
    ApiCourse()
      .GetCourseAttendeesListForNotificationPdfData(id)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/pdf",
        });
        
        // Generate filename from courseData
        let fileName = "CourseAttendees.pdf";
        if (courseData) {
          const courseName = courseData.courseName || "Course";
          const courseStartDate = courseData.courseStartDate 
            ? moment(courseData.courseStartDate).format("DD-MM-yyyy")
            : "Date";
          const courseLocation = courseData.courseLocation || "Location";
          
          // Sanitize filename by removing invalid characters
          const sanitizedName = courseName.replace(/[/\\?%*:|"<>]/g, "");
          const sanitizedLocation = courseLocation.replace(/[/\\?%*:|"<>]/g, "");
          
          // fileName = `${sanitizedName}_${courseStartDate}_${sanitizedLocation}.pdf`;
          fileName = `${sanitizedLocation}_${courseStartDate}_${sanitizedName}.pdf`;
        }
        
        saveAs(blob, fileName);
        ShowToast(toastId, "downloaded_pdf", "success");
      })
      .catch((err) => {
        console.log(err);
        ShowToast(toastId, "Failed to download PDF.", "error");
      })
      .then(() => {
        setLoading(false);
      });
  };
  
  return (
    <div>
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />

      {
        <div className="panel panel-primary noprint">
          <div className="panel-heading">
            <h4>{<GetLanguageString props="common_search" />}</h4>
          </div>
          <div className="panel-body">
            <Row>
              <Col md="3">
                <FormGroup>
                  <Label className="col-form-label">
                    {<GetLanguageString props="settings_notification_type" />}
                  </Label>
                  <Select
                    value={selectedType}
                    components={{ Option: customOption }}
                    options={notificationTypes.map((notification) => ({
                      value: notification.id,
                      label: notification.name,
                    }))}
                    className={
                      isUrdu(selectedType.label)
                        ? "basic-single ur"
                        : "basic-single"
                    }
                    classNamePrefix="select"
                    isClearable={false}
                    onChange={handleSelectChangeNotificationType}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <Label className="col-form-label">
                    {<GetLanguageString props="notifications_approve_status" />}
                  </Label>
                  <Select
                    value={selectedApprovalStatus}
                    options={approvalStatuses.map((approval) => ({
                      value: approval.statusId,
                      label: <GetLanguageString props={approval.code} />,
                    }))}
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={false}
                    onChange={handleSelectChangeApprovalStatus}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <Label className="col-form-label">
                    {<GetLanguageString props="notifications_requested_by" />}
                  </Label>
                  <Select
                    value={selectedUnit}
                    options={units.map((unit) => ({
                      value: unit.id + "-" + unit.responsibilityId,
                      label:
                        unit.id === 0 || unit.responsibilityId === 0
                          ? unit.name
                          : unit.responsibilityTitle + " / حلقہ : " + unit.name,
                    }))}
                    className="basic-single ur"
                    classNamePrefix="select"
                    isClearable={false}
                    onChange={handleSelectChangeUnit}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <Label className="col-form-label">
                    {<GetLanguageString props="notifications_requested_for" />}
                  </Label>
                  <Select
                    value={selectedRelevantUnit}
                    options={relevantUnitsList}
                    className="basic-single ur"
                    classNamePrefix="select"
                    isClearable={false}
                    onChange={handleSelectRelevantUnit}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <div className="ibox-content">
                  <Label className="col-form-label">
                    <h4>
                      {
                        <GetLanguageString props="notifications_creation_date" />
                      }
                    </h4>
                  </Label>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label className="col-form-label">
                          {<GetLanguageString props="member_report_from" />}
                        </Label>
                        <DatePicker
                          value={startDate}
                          showYearDropdown
                          placeholderText="dd/mm/yyyy"
                          className="form-control"
                          selected={startDate}
                          onChange={handleInputChangeStartDate}
                          dateFormat="dd/MM/yyyy"
                        />
                        {dateValidations.startDate && (
                          <h4 className="text-error">
                            {dateValidations.startDate}
                          </h4>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label className="col-form-label">
                          {<GetLanguageString props="member_report_to" />}
                        </Label>
                        <DatePicker
                          value={endDate}
                          showYearDropdown
                          placeholderText="dd/mm/yyyy"
                          className="form-control"
                          selected={endDate}
                          onChange={handleInputChangeEndDate}
                          dateFormat="dd/MM/yyyy"
                        />
                        {dateValidations.endDate && (
                          <h4 className="text-error">
                            {dateValidations.endDate}
                          </h4>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <br></br>
            <br></br>
            <Row>
              <Col className="text-center">
                <ButtonGroup>
                  <Button
                    color="primary"
                    className="m-l-sm"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    {<GetLanguageString props="common_search" />}
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </div>
        </div>
      }
      <div className="panel panel-primary noprint">
        <div className="panel-heading">
          <h4>{<GetLanguageString props="notifications_alerts" />}</h4>

          {notification.length !== 0 ? (
            <Button
              color="default"
              size="sm"
              style={{
                marginTop: -30,
              }}
              onClick={excelDownload}
              className={GetCustomStyles().btn_style}
            >
              {excelLoading ? (
                <Spinner size="sm" color="dark" />
              ) : (
                <>
                  <RiFileExcel2Line
                    size={15}
                    color="#009440"
                    style={{ marginRight: 3, marginBottom: 1 }}
                  />
                  <span style={{ color: "black" }}>
                    {<GetLanguageString props="member_report_export_excel" />}
                  </span>
                </>
              )}
            </Button>
          ) : null}
        </div>
        <div className="panel-body">
          {!loading ? (
            notification.length !== 0 ? (
              <Table responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      {
                        <GetLanguageString props="settings_notification_type_name" />
                      }
                    </th>
                    <th
                      className="cursor-pointer"
                      onClick={() => handleSorting("creationDate")}
                    >
                      {
                        <GetLanguageString props="notifications_creation_date" />
                      }
                      <span className={GetFooTableCustomStyles().span_style}>
                        {record.creationDate === "neutral" ? (
                          <>
                            <i
                              className={
                                GetFooTableCustomStyles().up_down_style
                              }
                            />
                            <i
                              className={
                                GetFooTableCustomStyles().down_up_style
                              }
                            />
                          </>
                        ) : record.creationDate === "ascending" ? (
                          <i className={GetFooTableCustomStyles().up_style} />
                        ) : (
                          <i className={GetFooTableCustomStyles().down_style} />
                        )}
                      </span>
                    </th>
                    {/* <th>
                      {<GetLanguageString props="notifications_approve_date" />}
                    </th> */}
                    <th>
                      {<GetLanguageString props="notifications_requested_by" />}
                    </th>
                    <th>
                      {
                        <GetLanguageString props="notifications_requested_for" />
                      }
                    </th>
                    <th>
                      {
                        <GetLanguageString props="notifications_approve_status" />
                      }
                    </th>
                    <th style={{ width: "200px" }}>
                      {
                        <GetLanguageString props="member_member_detail_course_comments" />
                      }
                    </th>
                    <th className="text-center">
                      {<GetLanguageString props="common_action" />}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {notification
                    .sort(function (a, b) {
                      if (a.startDate < b.startDate) return 1;
                      if (a.startDate > b.startDate) return -1;
                      return 0;
                    })
                    .map((record, index) => {
                      let isTextUrdu = isUrdu(record.comments);
                      let maxLength = isTextUrdu ? 50 : 45;

                      return (
                        <tr key={index}>
                          <td>{index + recordIndex}</td>
                          <td
                            className={
                              isUrdu(record.notificationTypeName) ? "ur" : ""
                            }
                          >
                            {record.notificationTypeName}

                            {/* Case 1: Course-related notification */}
                            {record.notificationTypeName?.includes("Course") &&
                            record.courseInfoModel ? (
                              <>
                                {" - "}
                                <span
                                  className="ur"
                                  style={{
                                    display: "inline",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {record.courseInfoModel?.courseName}
                                </span>
                                <span>
                                  {" ("}
                                  {applyClassToCharacters(
                                    record.courseInfoModel?.courseLocation ??
                                      "",
                                    "ur"
                                  )}
                                  {")"}
                                </span>
                              </>
                            ) : null}
                          </td>
                          <td>
                            {moment(
                              convertUTCToLocalTime(record.createdAt)
                            ).format("DD/MM/yyyy")}
                          </td>
                          <td className="ur">
                            {record.responsibilityName.length !== 0 ? (
                              <Label
                                className="label label-primary ur m-1"
                                size="m"
                              >
                                <h5>
                                  {record.responsibilityName +
                                    " / " +
                                    record.unitName}
                                </h5>
                              </Label>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="ur">
                            {record.code === "lfc_alert"
                              ? "-"
                              : record.relatedUnits?.length > 0
                              ? record.relatedUnits.map((item, index) => (
                                  <Label
                                    key={index}
                                    className="label label-info ur m-1"
                                    size="sm"
                                  >
                                    <h5>{item.label}</h5>
                                  </Label>
                                ))
                              : "-"}
                          </td>
                          <td
                            style={{
                              color:
                                record.approvalStatus === 1
                                  ? "Green"
                                  : record.approvalStatus === 2
                                  ? "Red"
                                  : record.approvalStatus === 4
                                  ? "Red"
                                  : record.approvalStatus === 0
                                  ? "Orange"
                                  : record.approvalStatus === 3
                                  ? "Gold"
                                  : record.approvalStatus === 5
                                  ? "Green"
                                  : record.approvalStatus === 6
                                  ? "Orange"
                                  : null,
                              fontWeight: "bold",
                            }}
                          >
                            {" "}
                            {record.approvalStatus === 1 ? (
                              <GetLanguageString props="notifications_approve" />
                            ) : record.approvalStatus === 2 ? (
                              <GetLanguageString props="notifications_reject" />
                            ) : record.approvalStatus === 4 ? (
                              <GetLanguageString props="notifications_cancel" />
                            ) : record.approvalStatus === 0 ? (
                              <GetLanguageString props="notifications_pending" />
                            ) : record.approvalStatus === 3 ? (
                              <GetLanguageString props="notifications_on_hold" />
                            ) : record.approvalStatus === 5 ? (
                              <GetLanguageString props="notifications_read" />
                            ) : record.approvalStatus === 6 ? (
                              <GetLanguageString props="notifications_unread" />
                            ) : null}
                          </td>
                          <td>
                            {record?.comments ? (
                              <Row>
                                <Col md="10">
                                  <span
                                    className={isTextUrdu ? "ur" : "en"}
                                    id={`tooltip-${index}`}
                                    onMouseEnter={() => toggleTooltip(index)}
                                    onMouseLeave={() => toggleTooltip(index)}
                                  >
                                    {isTextUrdu ? (
                                      <h4
                                        style={
                                          isTextUrdu
                                            ? { lineHeight: "1.8" }
                                            : {}
                                        }
                                      >
                                        {record.comments?.length > maxLength
                                          ? `${record.comments?.slice(
                                              0,
                                              maxLength
                                            )}...`
                                          : record.comments}
                                      </h4>
                                    ) : record.comments?.length > maxLength ? (
                                      `${record.comments?.slice(
                                        0,
                                        maxLength
                                      )}...`
                                    ) : (
                                      record.comments
                                    )}
                                    {record.comments?.length > maxLength ? (
                                      <Tooltip
                                        isOpen={tooltipOpen === index}
                                        target={`tooltip-${index}`}
                                        toggle={() => toggleTooltip(index)}
                                      >
                                        <h3
                                          className={isTextUrdu ? "ur" : "en"}
                                          style={
                                            isTextUrdu
                                              ? { lineHeight: "1.8" }
                                              : {}
                                          }
                                        >
                                          {record.comments}
                                        </h3>
                                      </Tooltip>
                                    ) : null}
                                  </span>
                                </Col>
                                <Col md="2">
                                  <TbCopy
                                    id={`tooltipCopy2-${index}`}
                                    style={{
                                      marginTop: 8,
                                      outline: "none",
                                      cursor: "pointer",
                                    }}
                                    color="#5a9b75 "
                                    size={20}
                                    onClick={() =>
                                      copyToClipboard(record.comments)
                                    }
                                  />
                                  <Tooltip
                                    isOpen={tooltipOpenCopy === index}
                                    target={`tooltipCopy2-${index}`}
                                    toggle={() => toggleTooltipCopy(index)}
                                  >
                                    <h5
                                      className={
                                        GetSelectedLanguage() === "ur"
                                          ? "ur"
                                          : "en"
                                      }
                                    >
                                      {"Copy Comment"}
                                    </h5>
                                  </Tooltip>
                                </Col>
                              </Row>
                            ) : null}
                          </td>
                          <td className="text-center">
                            {record.approvalStatus !== 4 &&
                            record.code.includes("course") ? (
                              <>
                                <Button
                                  color="default"
                                  size="sm"
                                  onClick={() => downloadPdf(record.id, record.courseInfoModel)}
                                >
                                  <RiFilePdf2Line
                                    size={15}
                                    color="#FF0000"
                                    className={GetCustomStyles().fa_style}
                                  />
                                  {
                                    <GetLanguageString props="member_add_rafiq_request_download_document" />
                                  }
                                </Button>
                              </>
                            ) : null}{" "}
                            {record.approvalStatus === 5 ? (
                              <>
                                <Button
                                  color="default"
                                  size="sm"
                                  onClick={() => {
                                    handleMarkAsReadOrUnread(
                                      record.id,
                                      6,
                                      index
                                    );
                                  }}
                                >
                                  <GoUnread
                                    size={16}
                                    color="#FFA500"
                                    style={{
                                      marginRight:
                                        GetSelectedLanguage() === "ur" ? -5 : 5,
                                      marginBottom: 1,
                                    }}
                                  />
                                  {
                                    <GetLanguageString
                                      props={"notifications_mark_unread"}
                                    />
                                  }
                                </Button>
                              </>
                            ) : record.approvalStatus === 6 ? (
                              <Button
                                color="default"
                                size="sm"
                                onClick={() => {
                                  handleMarkAsReadOrUnread(record.id, 5, index);
                                }}
                              >
                                <GoRead
                                  size={16}
                                  color="#008000"
                                  style={{
                                    marginRight:
                                      GetSelectedLanguage() === "ur" ? -5 : 5,
                                    marginBottom: 1,
                                  }}
                                />
                                {
                                  <GetLanguageString
                                    props={"notifications_mark_read"}
                                  />
                                }
                              </Button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                <tr>
                  <td colSpan="6">{pageInfo}</td>
                  <td colSpan="7">
                    <ul className={GetCustomStyles().page_style}>
                      <Pagination
                        activePage={pagination.activePage}
                        itemsCountPerPage={pagination.pageSize}
                        totalItemsCount={pagination.totalItem}
                        pageRangeDisplayed={pagination.pageRange}
                        onChange={handlePageChange}
                      />
                    </ul>
                  </td>
                </tr>
              </Table>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};
export default withRouter(NotificationAlerts);
